import axios from 'axios';

const API_URL = '/api/wholesale';

// Add axios interceptor for authentication
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const wholesaleService = {
  // Registration
  register: async (formData) => {
    try {
      const response = await axios.post(`${API_URL}/auth/register`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      console.error('Registration error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Products
  getProducts: async () => {
    try {
      const response = await axios.get(`${API_URL}/products`);
      if (!response.data) {
        throw new Error('No products data received');
      }
      return response.data;
    } catch (error) {
      console.error('Get products error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Orders
  createOrder: async (orderData) => {
    try {
      console.log('Creating order with data:', orderData); // Debug log
      const response = await axios.post(`${API_URL}/orders`, orderData);
      console.log('Order creation response:', response); // Debug log
  
      if (!response.data) {
        throw new Error('No response data received from server');
      }
  
      return response;
    } catch (error) {
      console.error('Create order error:', error);
      throw error.response?.data || error;
    }
  },

  getOrder: async (orderId) => {
    try {
      const response = await axios.get(`${API_URL}/orders/${orderId}`);
      if (!response.data) {
        throw new Error('Order not found');
      }
      return response.data;
    } catch (error) {
      console.error('Get order error:', error);
      throw error.response?.data || error.message;
    }
  },
  
  getOrders: async () => {
    try {
        const response = await axios.get(`${API_URL}/orders`);
        if (!response.data) {
            throw new Error('No orders data received');
        }
        return response.data;
    } catch (error) {
        console.error('Get orders error:', error);
        throw error.response?.data || error.message;
      }
  },
  calculateOrder: async (cart) => {
    try {
      if (!cart || Object.keys(cart).length === 0) {
        console.error('Empty cart received:', cart); // Added this line
        throw new Error('Cart is empty');
      }
  
      console.log('Calculating order with cart:', cart);
      console.log('Cart data being sent:', { cart });
  
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Not authenticated');
      }
  
      const response = await axios.post(`${API_URL}/orders/calculate`, { cart });
      console.log('Calculate response:', response.data);
  
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to calculate order');
      }
  
      return response.data;
    } catch (error) {
      console.error('Calculate order error:', error);
      console.error('Full error details:', error.response || error); // Added this line
      throw error.response?.data || error.message;
    }
  },

  getOrderInvoice: async (orderId) => {
    try {
      const response = await axios.get(`${API_URL}/orders/${orderId}/invoice`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Get order invoice error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Payment Methods
  getPaymentMethods: async () => {
    try {
      console.log('Fetching payment methods...');
      const response = await axios.get(`${API_URL}/customers/payment-methods`);
      console.log('Payment methods response:', response);
  
      // Response will be direct array, no need to check .success
      return response.data;
    } catch (error) {
      console.error('Get payment methods error:', error);
      console.error('Full error response:', error.response);
      throw error.response?.data || error.message;
    }
  },

  addPaymentMethod: async (paymentMethodId) => {
    try {
      const response = await axios.post(`${API_URL}/customers/payment-methods`, {
        paymentMethodId
      });
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to add payment method');
      }
      return response.data;
    } catch (error) {
      console.error('Add payment method error:', error);
      throw error.response?.data || error.message;
    }
  },
  
  setDefaultPaymentMethod: async (paymentMethodId) => {
    try {
      const response = await axios.post(`${API_URL}/customers/payment-methods/${paymentMethodId}/default`);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to set default payment method');
      }
      return response.data;
    } catch (error) {
      console.error('Set default payment method error:', error);
      throw error.response?.data || error.message;
    }
  },

  deletePaymentMethod: async (paymentMethodId) => {
    try {
      const response = await axios.delete(`${API_URL}/customers/payment-methods/${paymentMethodId}`);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete payment method');
      }
      return response.data;
    } catch (error) {
      console.error('Delete payment method error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Customer Profile
  getProfile: async () => {
    try {
      const response = await axios.get(`${API_URL}/customers/profile`);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to fetch profile');
      }
      return response.data.profile;
    } catch (error) {
      console.error('Get profile error:', error);
      throw error.response?.data || error.message;
    }
  },

  updateProfile: async (profileData) => {
    try {
      const response = await axios.put(`${API_URL}/customers/profile`, profileData);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to update profile');
      }
      return response.data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error.response?.data || error.message;
    }
  }
};

export default wholesaleService;